// extracted by mini-css-extract-plugin
export default {"input":"Toggle_input__ylE5G"};